var React = require('react');

function CaretDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15 4L8 11.5385L1 4","stroke":"#11AF00","strokeLinecap":"round","strokeLinejoin":"round"}));
}

CaretDown.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = CaretDown;

CaretDown.default = CaretDown;
